/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_TypeInputs */



/**
* | output |
* | --- |
* | "Job Type" |
*
* @param {Job_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_type = /** @type {((inputs?: Job_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Art der Stelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип работы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("职位类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("職種")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी का प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de vaga")
	return /** @type {LocalizedString} */ ("Job Type")
});